module.exports = __webpack_public_path__ + "img/lunbo52.54756f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo52.png
// module id = AjL+
// module chunks = 0